import HostNodeInterface from "../Interfaces/HostNodeInterface";
import BuildNodeInterface from "../Interfaces/BuildNodeInterface";
import Host from "../Interfaces/HostInterface";
import Build from "../Interfaces/BuildInterface";

export function isHostNodeInterface(
  data: HostNodeInterface | BuildNodeInterface,
): data is HostNodeInterface {
  return (data as HostNodeInterface).isChild !== undefined;
}